export var RestoreMissingNullValues = function (original, updated) {
    for (var field in original) {
        if (updated[field] === undefined) {
            updated[field] = null;
        }
    }
};
//# sourceMappingURL=NullValueFieldRestorer.js.map